module.exports = __webpack_public_path__ + "static/media/AvenirLTStd-Roman.b1d7c6e0.otf";